import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { useParams, useNavigate } from "react-router-dom"; 
import adminModel from "models/admin.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";


const EditCategory = () => {
  const { id } = useParams(); 
  const navigate = useNavigate(); 

  const [category , setCategory] = useState({})
  const [iconFile , setIconFile] = useState(null)
  const [loading, setLoading] = useState(false)

  const getExperienceCategory = async () => {
    setLoading(true)
    try {
      const {data} = await adminModel.getExperienceCategory(id)
      const response = data[0];
      setCategory(response)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      helper.sweetalert.toast(error.response?.data?.message || "An error occurred while fetching experience category", "error")  
    }
  }

  


  useEffect(() => {
    getExperienceCategory()
  }, [id]);

  const handleUpdateCategory = async (e) => {
    setLoading(true)
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", category.name);
    formData.append("priority", category.priority);
    formData.append("image", iconFile);

    try {
      const res = await adminModel.updateExperienceCategory(id , formData)
      console.log(res);
      setLoading(false)
      navigate("/admin/experience-categories"); 
    } catch (error) {
      setLoading(false)
      helper.sweetalert.toast(error.response?.data?.message || "An error occurred while updating experience category", "error")
    }
  };

  const handleIconChange = (e) => {
    const selectedFile = e.target.files[0];
    setIconFile(selectedFile);
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setCategory((prev) => ({
          ...prev,
          image: event.target.result,
        }));
      };
      reader.readAsDataURL(selectedFile);
    }
  }

  return loading ? <Loader/>  : (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Edit Category</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleUpdateCategory}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="categoryName">Category Name</Label>
                        <Input
                          type="text"
                          id="categoryName"
                          value={category.name}
                          onChange={(e) => setCategory(prev => ({...prev, name: e.target.value}))}
                          placeholder="Enter category name"
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label for="priority">Priority</Label>
                        <Input
                          type="number"
                          id="priority"
                          value={category.priority}
                          onChange={e => setCategory((prev => ({...prev , priority : Number(e.target.value)})))} 
                        >
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="icon">Icon / Image</Label>
                        <Input
                          type="file"
                          id="icon"
                          onChange={handleIconChange}
                          accept="image/*"
                        />
                        {category?.image && (
                          <img
                            src={category.image}
                            alt="Category Icon"
                            style={{ width: "40px", height: "40px", marginTop: "10px" }}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button color="primary" type="submit">
                    Update Category
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default EditCategory;
